import React, { ReactNode } from 'react';
import { KatPopover } from '@amzn/katal-react';
import Link from 'next/link';
import { Media } from 'src/utils/media';
import { UrlObject } from 'url';

export interface CategoryCardProps {
  categoryName: string,
  icon: ReactNode,
  description: string,
  href: UrlObject,
  onClick: Function;
}

export const CategoryCardContainerLayout: React.FC<CategoryCardProps> = ({
  categoryName,
  icon,
  description,
  href,
  onClick,
}) => (
  <div>
    <Media between={['xs', 'md']}>
      <div data-testid="category-card" className="bg-kat-white hover:border-kat-jungle-mist">
        <Link
          href={href}
          data-testid="category-card-link"
          className="w-fit font-medium no-underline"
          onClick={() => onClick()}
        >
          <div className="flex h-full flex-col justify-between">
            <div className="flex flex-row gap-x-2">
              {icon}
              <div className="">
                <h3
                  slot="trigger"
                  className="my-0 text-[14px] leading-[18px] text-kat-nordic hover:underline"
                >
                  {categoryName}
                </h3>
                <div className="pb-[18px] pt-[6px] font-normal text-kat-tarpon">{description}</div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </Media>
    <Media greaterThanOrEqual="md">
      <div data-testid="category-card" className="h-[38px] border border-solid border-kat-zircon bg-kat-white hover:border-kat-jungle-mist">
        <Link
          href={href}
          data-testid="category-card-link"
          className="w-fit font-medium no-underline"
          onClick={() => onClick()}
        >
          <div className="flex h-full flex-col justify-between px-4 py-2.5">
            <div className="flex flex-row items-center gap-x-2">
              {icon}
              <KatPopover
                kat-aria-behavior="tooltip"
                position="top"
                triggerType="hover"
                variant="tooltip"
              >
                <h3
                  slot="trigger"
                  className="my-0 text-[13px] font-bold leading-[18px] text-kat-nordic hover:underline"
                >
                  {categoryName}
                </h3>
                <div className="font-normal">
                  {description}
                </div>
              </KatPopover>
            </div>
          </div>
        </Link>
      </div>
    </Media>
  </div>
);
